import React, { useEffect, useState } from 'react';
import AsyncSelect from 'react-select/async';
import {
    firebaseFire as Libfirebase,
} from '../../helpers/firebase-config.js';
var timer
const DropDownDoencas = ({ placeholder, change, value }) => {

    const [doencaSelecionada, setDoencaSelecionada] = useState(value)

    useEffect(() => {
        if (value && value.codigo && value.codigo !== "") {
            const data = {
                value: value,
                label: `${value.codigo ? value.codigo : "Sem Cód."} | ${value.doenca} | ${value.descricao}`
            }
            setDoencaSelecionada(data)
        }
    }, [])

    const getDoencasAlgolia = (busca) => {
        const algoliasearch = require("algoliasearch");
        const client = algoliasearch("S4T1I4OXWN", "01bed30f13ef39976e5b4204eba41be4");
        const index = client.initIndex("doencas");
        let listDoencas = []
        return new Promise(function (resolve, reject) {
            index
                .search(
                    busca,
                    { attributesToHighlight: [] }
                ).then(({ hits }) => {
                    hits.forEach(h => {
                        let data = {
                            ref: Libfirebase.doc(h.path),
                            id: h.objectID,
                            ...h
                        };

                        listDoencas.push(data)
                    });
                    resolve(listDoencas)
                }).catch(err => {
                    console.log(err);
                    reject(err)
                });
        })
    }

    const promiseOptions = (inputValue) => {
        console.log(inputValue)
        return new Promise((resolve) => {
            clearTimeout(timer);

            timer = setTimeout(async () => {
                if (inputValue !== "") {
                    let cidades = await getDoencasAlgolia(inputValue)
                    let items = cidades.map(
                        (res, i) => {
                            return {
                                value: res,
                                label: `${res.codigo ? res.codigo : "Sem Cód."} | ${res.doenca} | ${res.descricao}`
                            }
                        }
                    )
                    resolve(items)
                }
            }, 1000);
        });
    }

    return (
        <div className="mb-1">
            <AsyncSelect
                value={doencaSelecionada}
                placeholder={placeholder}
                loadOptions={promiseOptions}
                noOptionsMessage={() => "Nenhum resultado encontrado"}
                onChange={v => {
                    setDoencaSelecionada(v)
                    change(v)
                }} />
        </div>
    );

}

export default DropDownDoencas